import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IncubateeRoutingModule } from './incubatee-routing.module';
import { IncubateePageComponent } from './components/incubatee-page/incubatee-page.component';
import { IncubateeListComponent } from './components/incubatee-list/incubatee-list.component';
import { IncubateeAddComponent } from './components/incubatee-add/incubatee-add.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { IonicModule } from '@ionic/angular';
import { BsDatepickerModule, DatepickerModule } from 'ngx-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';


@NgModule({
  declarations: [IncubateePageComponent, IncubateeListComponent, IncubateeAddComponent],
  imports: [
    CommonModule,
    IncubateeRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
    DatepickerModule,
    BsDatepickerModule.forRoot(),
    NgxMatSelectSearchModule,
  ],
  // entryComponents: [
  //   IncubateeAddComponent
  // ]
})
export class IncubateeModule { }
